import React from 'react';
import { TIPTAP_POLL_TYPE } from 'ricos-content';
import type { RicosServices, ToolbarButton } from 'ricos-types';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import { selectedNodeResolver } from 'wix-rich-content-plugin-commons';

import type { SettingsModalProps } from './components/settings-modal';
import { SettingsModal } from './components/settings-modal';
import {
  POLL_BUTTONS,
  POLL_SETTINGS_DESIGN_MODAL_ID,
  POLL_SETTINGS_MODAL_ID,
  SETTINGS_TAB,
} from './consts';
import { PollDesignButton } from './toolbar/PollDesignButton';
import { PollLayoutButton } from './toolbar/PollLayoutButton';
import PollLayoutPanel from './toolbar/PollLayoutPanel';
import type { PollPluginEditorConfig } from './types';

export const getToolbarButtons = (
  config: PollPluginEditorConfig,
  services: RicosServices
): ToolbarButton[] => {
  const { modals } = services;
  return [
    {
      id: POLL_BUTTONS.layout,
      dataHook: 'baseToolbarButton_layout',
      attributes: {
        selectedNode: selectedNodeResolver,
      },
      modal: {
        Component: PollLayoutPanel,
        id: POLL_BUTTONS.layout,
      },
      command: ({ value, editorCommands, attributes: { selectedNode } }) => {
        editorCommands
          .chain()
          .focus()
          .updateAttributes(TIPTAP_POLL_TYPE, {
            layout: {
              poll: { ...selectedNode.attrs.layout.poll, type: value },
            },
          })
          .run();
      },
      renderer: toolbarItem => (
        <PollLayoutButton toolbarItem={toolbarItem} id={POLL_BUTTONS.layout} config={config} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: POLL_SETTINGS_DESIGN_MODAL_ID,
      dataHook: 'baseToolbarButton_design',
      modal: {
        Component: SettingsModal,
        id: POLL_SETTINGS_DESIGN_MODAL_ID,
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        const componentProps: SettingsModalProps = {
          nodeId: selectedNode.attrs.id,
          activeTab: SETTINGS_TAB.design,
          config,
        };
        modals?.openModal(POLL_SETTINGS_MODAL_ID, {
          componentProps,
          positioning: { placement: 'right' },
          layout: isMobile ? 'fullscreen' : 'drawer',
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver,
      },
      renderer: toolbarItem => <PollDesignButton toolbarItem={toolbarItem} />,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: SettingsModal,
        id: POLL_SETTINGS_MODAL_ID,
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        const componentProps: SettingsModalProps = {
          nodeId: selectedNode.attrs.id,
          activeTab: SETTINGS_TAB.settings,
          config,
        };
        modals?.openModal(POLL_SETTINGS_MODAL_ID, {
          componentProps,
          positioning: { placement: 'right' },
          layout: isMobile ? 'fullscreen' : 'drawer',
        });
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
    },
  ];
};
